import * as angular from 'angular';

export class UrlRegexValidator implements ng.IDirective {
    public require = 'ngModel';
    public restrict = 'A';
    public scope = false;

    public link: ng.IDirectiveLinkFn = (
        scope: ng.IScope,
        element: JQuery,
        attributes: ng.IAttributes,
        ngModelCtrl: ng.INgModelController
    ) => {
        ngModelCtrl.$validators['pkpUrlRegexValidator'] = this.validate;
    };

    /**
     * Checks the basic syntax of the specified URL string using a regular expression.
     * Note that the schema could also be optional, but without http(s) a browser won't do correct hyperlink.
     *
     * An alternative would be to validate in the view using the following notation:
     *   <pre>&lt;input type="text" ng-pattern="/^https?:\/\/(([a-zA-Z0-9][a-zA-Z0-9\.\-]{0,61})?[a-zA-Z0-9]\.){1,127}[a-zA-Z]{2,63}/" ng-model="website"&gt;</pre>
     * Note the additional slashes at start and end of the pattern.
     *
     * See also e-mail address validation in pkp-web/de.tracx.pkp.core.view.validate.MailAddressValidator
     *
     * @param modelValue the string to be validated as URL
     * @returns true if URL looks valid
     * @see <a href="https://stackoverflow.com/questions/43341426/validate-url-with-angularjs-and-html-5">Stack Overflow: Validate URL with AngularJS and HTML 5</a>
     */
    public validate(modelValue) {
        if (
            modelValue === undefined ||
            modelValue === null ||
            modelValue === ''
        ) {
            return true;
        }
        const urlPattern =
            /^https?:\/\/(([a-zA-Z0-9][a-zA-Z0-9.-]{0,61})?[a-zA-Z0-9]\.){1,127}[a-zA-Z]{2,63}/;
        return urlPattern.test(modelValue);
    }
}

angular
    .module('app')
    .directive('pkpUrlRegexValidator', () => new UrlRegexValidator());
